import gql from 'graphql-tag'

export default gql`mutation {
  updateViewedNotificationsAt{
    viewed_notifications_at
  }
}`